<div>
  <router-outlet></router-outlet>
</div>



// WEBPACK FOOTER //
// ./src/app/developer/logs/logs.component.html